import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import {
  returnValue,
  returnUserContent,
  returnBlockValue,
} from '@/utils/op-types/helperFunctions'

import Input from '@/components/optypes/headlesss-components/Input'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const Block = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div>
      {returnBlockValue('title', 'content', opBlocks[block], content) !==
        '' && (
        <div className="text-lg font-bold mb-4">
          {returnBlockValue('title', 'content', opBlocks[block], content)}
        </div>
      )}

      <div className=" ">
        <Input
          className="border-2  rounded shadow-inner p-4 placeholder-gray-400 text-xl  focus:outline-none focus:ring-2 focus:ring-transparent"
          style={{
            backgroundColor: returnValue('inputbgcolor', opDesign, pageDesign),
            borderColor: returnValue('inputbordercolor', opDesign, pageDesign),
            color: returnValue('inputtextcolor', opDesign, pageDesign),
          }}
          blockId={id}
          contentKey="value"
          placeholder={returnBlockValue(
            'placeholder',
            'content',
            opBlocks[block],
            content
          )}
          onEnter={() => {}}
        />
      </div>
    </div>
  )
}

export default Block
